export default "__VITE_ASSET__7e6e7321__"